import * as S from './styled';

export const LinearProgressBar = () => (
  <S.ProgressBarContainer>
    <S.ProgressBarFiller />
  </S.ProgressBarContainer>
);
